import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, Clock, Check } from 'lucide-react';
export const Pricing = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <section id="pricing-section" className="py-20 bg-barre-pink text-white relative overflow-hidden" data-id="element-93">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-94"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-95">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl text-center text-gray-900 border-4 border-barre-border" data-id="element-96">
          <div className="flex items-center justify-center gap-2 text-barre-pink font-bold mb-6" data-id="element-97">
            <Clock className="w-5 h-5 animate-pulse" data-id="element-98" />
            <span data-id="element-99">LA OFERTA TERMINA EN:</span>
            <div className="flex gap-1 text-xl" data-id="element-100">
              <span className="bg-barre-blush px-2 py-1 rounded" data-id="element-101">
                {formatTime(timeLeft.hours)}
              </span>
              :
              <span className="bg-barre-blush px-2 py-1 rounded" data-id="element-102">
                {formatTime(timeLeft.minutes)}
              </span>
              :
              <span className="bg-barre-blush px-2 py-1 rounded" data-id="element-103">
                {formatTime(timeLeft.seconds)}
              </span>
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-104">
            Empezá tu evolución hoy
          </h2>

          <p className="text-lg text-gray-600 mb-8" data-id="element-105">
            Llevate los 6 tomos digitales + los 5 bonos exclusivos de regalo.
          </p>

          <div className="mb-8" data-id="element-106">
            <p className="text-gray-400 text-xl font-medium line-through mb-2" data-id="element-107">
              Precio regular: $49.990
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-108">
              <span className="text-2xl font-bold text-gray-500" data-id="element-109">AR$</span>
              <span className="text-6xl md:text-7xl font-extrabold text-barre-pink tracking-tight" data-id="element-110">
                19.990
              </span>
            </div>
            <p className="text-sm text-green-600 font-bold mt-2 bg-green-50 inline-block px-3 py-1 rounded-full" data-id="element-111">
              Ahorrás $30.000
            </p>
          </div>

          <ul className="text-left max-w-md mx-auto space-y-3 mb-10" data-id="element-112">
            {['Acceso inmediato y de por vida', 'Material descargable', 'Actualizaciones futuras gratis', 'Soporte por email'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700 font-medium" data-id="element-113">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-114" />
                {item}
              </li>)}
          </ul>

          <motion.a href="https://checkout.ebookbtnlines.shop/cart/45473435254831:1" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-barre-pink hover:bg-barre-pinkHover text-white font-bold py-5 px-8 rounded-2xl shadow-lg shadow-barre-pink/30 transition-all text-xl md:text-2xl flex items-center justify-center gap-3" data-id="element-115">
            <ShoppingCart className="w-6 h-6" data-id="element-116" />
            QUIERO SUMAR BARRE A MI ESTUDIO
          </motion.a>

          <p className="mt-6 text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-117">
            🔒 Pago 100% seguro y encriptado
          </p>
        </div>
      </div>
    </section>;
};